<template>
    <div class="pt-8">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Metadata</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 pr-3">
            <table class="w-full table-fixed">
                <thead>
                <tr>
                    <th style="width: 40%"></th>
                    <th style="width: 19%"></th>
                    <th style="width: 41%"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td colspan="3" class="pt-0">
                        <div class="relative">
                            <div class="border-t border-gray-200 my-3"></div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <div class="text-xs px-2 py-0 bg-gray-50 text-gray-400 font-semibold">
                                    Created by
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm items-center" colspan="3">
                        <div class="flex items-center justify-center">
                            <div class="text-sm px-2 py-0 bg-gray-50 text-gray-800 font-medium"
                                 v-text="rams.createdBy">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="text-sm items-center" colspan="3">
                        <div class="flex items-center justify-center">
                            <div class="text-sm px-2 py-0 bg-gray-50 text-gray-800 font-medium"
                                 v-text="moment(rams.createdOn).format('Do MMMM YYYY, h:mm a')">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="rams.lastUpdatedBy && (rams.lastUpdatedOn !== rams.createdOn)">
                    <td colspan="3" class="pt-2">
                        <div class="relative">
                            <div class="border-t border-gray-200 my-3"></div>
                            <div class="absolute inset-0 flex items-center justify-center">
                                <div class="text-xs px-2 py-0 bg-gray-50 text-gray-400 font-semibold">
                                    Last Updated by
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="rams.lastUpdatedBy && (rams.lastUpdatedOn !== rams.createdOn)">
                    <td class="text-sm items-center" colspan="3">
                        <div class="flex items-center justify-center">
                            <div class="text-sm px-2 py-0 bg-gray-50 text-gray-800 font-medium"
                                 v-text="rams.lastUpdatedBy">
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="rams.lastUpdatedBy && (rams.lastUpdatedOn !== rams.createdOn)">
                    <td class="text-sm items-center" colspan="3">
                        <div class="flex items-center justify-center">
                            <div class="text-sm px-2 py-0 bg-gray-50 text-gray-800 font-medium"
                                 v-text="moment(rams.lastUpdatedOn).format('Do MMMM YYYY, h:mm a')">
                            </div>
                        </div>
                    </td>
                </tr>

                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

import {RAMS} from "@models";
import UiInput from "../../ui/UiInput.vue";
import moment from "moment";

export default {
    components: {UiInput},
    props: {
        rams: RAMS,
    },
    watch: {
        rams: {
            handler(newValue, oldValue) {
            },
            deep: true,
        },
    },
    data() {
        return {
            moment
        }
    },
    methods: {},
}
</script>
